import React from "react";
import { Box, Pagination, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const PaginationWithIcons = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Pagination Icon Buttons
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          language="js"
          title={"Pagination with next/prev, first/last page buttons and button-hidden"}
          value={"         <Pagination count={10} showFirstButton showLastButton />\n" +
              "            <Pagination count={10} hidePrevButton hideNextButton />"}
        >
          <Stack direction={"column"} spacing={2} alignItems={"center"}>
            <Pagination count={10} showFirstButton showLastButton />
            <Pagination count={10} hidePrevButton hideNextButton />
              <Pagination count={10} variant={"outlined"} shape={"rounded"} showFirstButton showLastButton />
            <Pagination count={10} variant={"outlined"} shape={"rounded"} hidePrevButton hideNextButton />
          </Stack>
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default PaginationWithIcons;
